export default __webpack_public_path__ + "static/media/loincloth_of_the_forsaken.1f07650a.jpg";